import React from "react";

/** Explains how a date's capacity figure was arrived at, so numbers are auditable. */
export function CapacityNote({ detail, testid = "capacity-note" }) {
  if (!detail) return null;
  const bits = [];
  if (detail.per_ticket_type) {
    bits.push(`${detail.per_ticket_type} only`);
    if (detail.all_types_capacity != null) bits.push(`whole night ${detail.all_types_capacity.toLocaleString("en-GB")}`);
  } else if (detail.by_type?.length) {
    bits.push(detail.by_type.map((t) => `${t.name} ${t.capacity == null ? "no limit set" : t.capacity.toLocaleString("en-GB")}`).join(" + "));
  }
  if (detail.is_slotted) bits.push(`${detail.slots_counted} slot${detail.slots_counted === 1 ? "" : "s"}`);
  if (detail.slots_unavailable > 0) bits.push(`not available on ${detail.slots_unavailable} slot${detail.slots_unavailable === 1 ? "" : "s"}`);
  if (detail.slots_paused > 0) bits.push(`${detail.slots_paused} paused excluded`);
  if (detail.capped_by_hard_cap) bits.push(`capped from ${detail.raw_total.toLocaleString("en-GB")} by date max ${Number(detail.hard_cap).toLocaleString("en-GB")}`);
  if (!bits.length) return null;
  return <div className="text-[10px] text-[#7a7a7a] mt-1 leading-snug" data-testid={testid}>{bits.join(" · ")}</div>;
}

export default CapacityNote;
